import { useState } from 'react';
import SectionHeader from './SectionHeader';

const ITEMS = [
  { key: 'c1', text: '封面与首帧：是否依赖「下一秒会越界」的构图制造点击？', note: '视觉层是最先被扫的维度' },
  { key: 'c2', text: '衣着与机位：是否有透视、局部特写或刻意贴身的摆拍？', note: '动态动作 + 静态服装分开看' },
  { key: 'c3', text: '文案与标题：有没有用谐音 / 缩写绕关键词或做强暗示？', note: '话术层容易被连坐判定' },
  { key: 'c4', text: '话题与标签：所挂话题是否和内容调性一致、易引歧义？', note: '话题错配会放大风险' },
  { key: 'c5', text: '评论区与置顶：是否有意在往越线方向引导互动？', note: '互动区是环境维度的重点' },
  { key: 'c6', text: '受众范围：内容是否容易被未成年账号高频触达？', note: '一旦命中保护逻辑按最重档' },
];

export default function Checklist() {
  const [checked, setChecked] = useState<Record<string, boolean>>({});

  const done = ITEMS.filter((i) => checked[i.key]).length;

  return (
    <section id="checklist" className="relative overflow-hidden bg-foreground-950 py-14 md:py-20">
      <div className="pointer-events-none absolute -right-20 -top-20 h-64 w-64 rounded-full bg-primary-500/10 blur-3xl" />
      <div className="pointer-events-none absolute -bottom-24 -left-16 h-72 w-72 rounded-full bg-accent-500/10 blur-3xl" />

      <div className="relative mx-auto w-full max-w-7xl px-4 md:px-6">
        <div className="grid gap-10 lg:grid-cols-[1fr_1.15fr] lg:gap-14">
          <div>
            <SectionHeader
              tone="light"
              eyebrow="51擦边 · 发布自查"
              title="上架前，把这几条过一遍"
              desc="被「擦边」卡住的人，多数不是画面本身有问题，而是没在发布前把上面这几个变量组合起来检查。对照着勾，能省下一次下架。
"
            />
            <div className="mt-6 rounded-2xl border border-background-50/10 bg-background-50/5 p-5">
              <div className="flex items-center justify-between text-sm text-background-50">
                <span className="font-semibold">当前自测进度</span>
                <span className="font-serif text-lg font-black text-accent-300">
                  {done}<span className="text-background-50/40"> / {ITEMS.length}</span>
                </span>
              </div>
              <div className="mt-3 h-2 overflow-hidden rounded-full bg-background-50/10">
                <div
                  className="h-full rounded-full bg-accent-400 transition-all duration-500"
                  style={{ width: `${(done / ITEMS.length) * 100}%` }}
                />
              </div>
              <p className="mt-3 text-xs leading-relaxed text-background-50/60">
                勾满 6 项仍不代表绝对安全——平台判定是动态组合。此清单只是把「最常见踩线点」前置。
              </p>
            </div>
          </div>

          <div className="space-y-3">
            {ITEMS.map((item) => {
              const on = !!checked[item.key];
              return (
                <button
                  key={item.key}
                  onClick={() => setChecked((prev) => ({ ...prev, [item.key]: !prev[item.key] }))}
                  className={`flex w-full items-start gap-3 rounded-2xl border p-4 text-left transition-colors ${
                    on
                      ? 'border-accent-500/50 bg-accent-500/10'
                      : 'border-background-50/10 bg-background-50/5 hover:bg-background-50/10'
                  }`}
                >
                  <span
                    className={`mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full border transition-colors ${
                      on ? 'border-accent-400 bg-accent-400 text-foreground-950' : 'border-background-50/30 text-transparent'
                    }`}
                  >
                    <i className="ri-check-line text-sm font-bold" />
                  </span>
                  <span className="min-w-0">
                    <span className={`block text-sm font-medium ${on ? 'text-background-50' : 'text-background-50/90'}`}>
                      {item.text}
                    </span>
                    <span className="mt-1 block text-xs text-background-50/50">{item.note}</span>
                  </span>
                </button>
              );
            })}
            <p className="pt-1 text-xs text-background-50/45">
              * 此清单为本站整理参考，不构成平台官方判定依据。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}